import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import AddOnsIntroPanel from './add-ons-intro-panel';
import AddItemsFormContainer from '../app-main/components/reduxForms/forms/AddItemsForm/AddItemsFormContainer';
import ModalManagerV2 from '../elements-modal/modal-manager-v2';
import { CreateAddOnModal } from './modals/create-add-on-modal';
import { AddtlTaxFeesModal } from './modals/addtl-tax-fees-modal';
import EditAddOnModal from './modals/edit-add-on-modal';
import DeleteAddonModal from './modals/DeleteAddonModal';
import AddItemModal from './modals/add-item-modal';
import AddonsBanner from './AddonsBanner';
import EditBookingAddOnModal from './modals/edit-booking-add-on-modal';
import { ItemDetailsModal } from './modals/item-details-modal';
import { fetchRegionalFees } from '../app-main/actions/fees';
import { collectVatCopy, addOnTaxTypeOptions } from './utils';
import { get, filter, map, isEmpty } from 'lodash';
import { intlShape } from 'react-intl';


class CustomOfferAddOnsPage extends Component {
  constructor (props) {
    super(props);

    this.state = {
      isCanada: false,
      feeProfile: {}
    }
  }

  componentDidMount () {
    const { dispatch, accessToken,
      feeProfiles = {}, isVatEnabled = false } = this.props;

    window.scrollTo(0, 0);
    this.props.scrollToTop();

    if (isVatEnabled) {
      const vatAddress = get(feeProfiles, 'vatAddresses.data[0]');
      const billingAddress = get(feeProfiles, 'billingAddress.data[0]');
      const feeProfile = vatAddress || billingAddress;
      const isCanada = 'CA' === get(feeProfile, 'country');

      this.setState({
        isCanada,
        feeProfile
      });

      const getRegionalFeesPayload = {
        country: get(feeProfile, 'country'),
        ...(isCanada && { state: get(feeProfile, 'state') })
      };

      dispatch(fetchRegionalFees(accessToken, getRegionalFeesPayload));
    }
  }

  render () {
    const {
      booking,
      inventory,
      createItem,
      addAddtlTaxorFee,
      addOns,
      item,
      addOnsForm,
      toggleModal,
      openModal,
      whichModal,
      onModalClose,
      isFetchingItem,
      isSubmitting,
      isMobile,
      addItemId,
      addItem,
      getInventoryItem,
      editBookingAddOn,
      openEditBookingAddOnModal,
      navigateBack,
      currency,
      isEditOffer,
      showAddOnsPanel,
      closePanel,
      iosWebView,
      scrollToTop,
      isHostUpdate,
      contracts,
      deleteItem,
      dispatch,
      fees = {},
      isVatEnabled = false,
      intl
    } = this.props;
    const listingUseType = get(booking, 'listing.use_type');
    const feeTypes = get(fees, 'feeTypes', []);
    const federalFee = filter(feeTypes, (feeType) => { return !feeType.is_subregion; });
    const federalFeeName = this.state.isCanada ? 'other' : get(federalFee, '[0].name', 'other');
    const feeTypeNames = isEmpty(feeTypes) ?
      ['sales_tax']
      :
      map(feeTypes, (feeType) => {
        return feeType.name;
      });

    const intlCollectVatCopy = collectVatCopy[federalFeeName];

    const intlAddOnTaxTypes = [...feeTypeNames, 'other']
      .map((feeTypeName) => {
        const formatMessageConfig =
          addOnTaxTypeOptions[feeTypeName] || addOnTaxTypeOptions.other;

        return {
          value: feeTypeName,
          label: intl.formatMessage(formatMessageConfig)
        };
      });

    return (
      <div className="AddOnsStep add-ons-step flex-one" data-testing-id="add-ons-page">
        <ModalManagerV2 whichModal={whichModal} toggleModal={toggleModal}>
          <CreateAddOnModal
            id="createAddOnModal"
            currency={currency}
            createItem={createItem}
            onModalClose={onModalClose}
            isSubmitting={isSubmitting}
            isMobile={isMobile}
            toggleModal={toggleModal}
            iosWebView={iosWebView}
            whichModal={whichModal}
            scrollToTop={scrollToTop}
            booking={booking}
            spaceId={get(booking, 'space_id')}
            contracts={contracts}
            intlCollectVatCopy={intlCollectVatCopy}
            intlAddOnTaxTypes={intlAddOnTaxTypes}
            isVatEnabled={isVatEnabled}
          />

          <AddtlTaxFeesModal
            id="addtlTaxFeesModal"
            currency={currency}
            addAddtlTaxorFee={addAddtlTaxorFee}
            toggleModal={toggleModal}
          />

          <ItemDetailsModal
            id={`viewAddOnDetailsModal-${item._id}`}
            toggleModal={toggleModal}
            isFetchingItem={isFetchingItem}
            item={item}
            whichModal={whichModal}
            iosWebView={iosWebView}
            currency={currency}
            isVatEnabled={isVatEnabled}
          />

          <EditAddOnModal
            id="editAddOnModal"
            currency={currency}
            createItem={createItem}
            isFetchingItem={isFetchingItem}
            isSubmitting={isSubmitting}
            toggleModal={toggleModal}
            scrollToTop={scrollToTop}
            iosWebView={iosWebView}
            whichModal={whichModal}
            spaceId={get(booking, 'space_id')}
            dipatch={dispatch}
            intlCollectVatCopy={intlCollectVatCopy}
            intlAddOnTaxTypes={intlAddOnTaxTypes}
            isVatEnabled={isVatEnabled}
          />

          <DeleteAddonModal
            id="deleteAddOnModal"
            toggleModal={toggleModal}
            deleteItem={deleteItem}
          />

          <AddItemModal
            id="addItemModal"
            currency={currency}
            addItemId={addItemId}
            addItem={addItem}
            iosWebView={iosWebView}
            whichModal={whichModal}
            scrollToTop={scrollToTop}
            toggleModal={toggleModal}
          />

          <EditBookingAddOnModal
            id="editBookingAddOnModal"
            currency={currency}
            editBookingAddOn={editBookingAddOn}
            getInventoryItem={getInventoryItem}
            openEditBookingAddOnModal={openEditBookingAddOnModal}
            iosWebView={iosWebView}
            whichModal={whichModal}
            toggleModal={toggleModal}
            dispatch={dispatch}
          />
        </ModalManagerV2>

        <div className="add-ons-page-panels flex column">
          <AddOnsIntroPanel
            listingUseType={listingUseType}
            showAddOnsPanel={showAddOnsPanel}
            closePanel={closePanel}
          />
          <AddItemsFormContainer
            inventory={inventory}
            currency={currency}
            addOns={addOns}
            addOnsForm={addOnsForm}
            openModal={openModal}
            toggleModal={toggleModal}
            isMobile={isMobile}
            getInventoryItem={getInventoryItem}
            editBookingAddOn={editBookingAddOn}
            openEditBookingAddOnModal={openEditBookingAddOnModal}
            navigateBack={navigateBack}
            isEditOffer={isEditOffer}
            bookingId={booking._id}
            isHostUpdate={isHostUpdate}
          />
        </div>
        <AddonsBanner />
      </div>
    );
  }
}

CustomOfferAddOnsPage.propTypes = {
  createItem: PropTypes.func,
  toggleModal: PropTypes.func,
  openModal: PropTypes.func,
  onModalClose: PropTypes.func,
  booking: PropTypes.object,
  inventory: PropTypes.object,
  addOns: PropTypes.object,
  addOnsForm: PropTypes.object,
  item: PropTypes.object,
  whichModal: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object
  ]),
  isSubmitting: PropTypes.bool,
  isFetchingItem: PropTypes.bool,
  isMobile: PropTypes.bool,
  addItemId: PropTypes.string,
  openEditBookingAddOnModal: PropTypes.func,
  isEditOffer: PropTypes.bool,
  getInventoryItem: PropTypes.func,
  editBookingAddOn: PropTypes.func,
  showAddOnsPanel: PropTypes.bool,
  scrollToTop: PropTypes.func,
  addItem: PropTypes.func,
  navigateBack: PropTypes.func,
  currency: PropTypes.string,
  closePanel: PropTypes.func,
  iosWebView: PropTypes.bool,
  addAddtlTaxorFee: PropTypes.func,
  deleteItem: PropTypes.func,
  isHostUpdate: PropTypes.bool,
  contracts: PropTypes.array,
  dispatch: PropTypes.func,
  feeProfiles: PropTypes.object,
  accessToken: PropTypes.string,
  feeTypes: PropTypes.array,
  fees: PropTypes.object,
  isVatEnabled: PropTypes.bool,
  intl: intlShape
};

function mapStateToProps (state, ownProps) {
  return {
    ...ownProps,
    fees: state.fees
  };
}

export default connect(mapStateToProps)(CustomOfferAddOnsPage);
